import { type Assessment } from 'shared/types'

import { type Entity, type OptIns, type Subject } from '~/domains/platform/infra/deus-ex-machina/ports'

import { type KYC } from '../kyc-onboarding.component'

const pendingAssessmentStatuses: Assessment['status'][] = ['requested', 'partially_rejected']

export type OnboardingSubject = Pick<Subject<OptIns>, 'kyc'> & Partial<Pick<Subject<OptIns>, 'unsafe'>>

export const organizationAccountRequestStatus = (
  entity?: Pick<Entity<'banking' | 'acquirer'>, 'id' | 'stoneAccount'>,
  subject?: Partial<OnboardingSubject>
): Extract<KYC, 'responsePending' | 'analysis'> | undefined => {
  if (entity?.stoneAccount?.situation === 'one_stone') return undefined

  const [type, organizationId] = entity?.id?.split(':') ?? []

  if (type !== 'organization') return undefined

  const accountRequests = subject?.unsafe?.entitiesKycRequests?.filter(
    assessment => assessment.reason === 'account_request' && assessment.organizationId === organizationId
  )

  if (accountRequests?.some(assessment => pendingAssessmentStatuses.includes(assessment.status))) {
    return 'responsePending'
  }

  if (accountRequests?.some(assessment => assessment.status === 'answered')) return 'analysis'

  return undefined
}
